// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"b9378afb","977":"8d6ec2c9"}[chunkId] + ".chunk.js");